const paginationLocale = {
  detail: "显示 {{pageStart}}-{{pageEnd}} 共 {{total}} 条",
  first: "首页",
  previous: "上一页",
  next: "下一页",
  last: "末页",
  morePages: "更多页",
  page: "{{page}} / 页"
};
export {
  paginationLocale
};
//# sourceMappingURL=zh_CN.js.map
